import { toast } from "react-toastify";
import { useMutation } from "@apollo/client/react";
import {
  DecisionType,
  RulesDocument,
  CreateRuleMutation,
  CreateRuleMutationVariables,
  CreateRuleDocument,
} from "@/graphql/__generated__/graphql";
import useUserStore from "@/store/shield";
import { useTranslation } from "react-i18next";
import { CustomToastComponent } from "@/components/shared";

export default function useCreateRuleMutationHook(
  decisionType?: DecisionType
): { createRuleMutation: any; loading: any; error: any } {
  const { t } = useTranslation(["toasts"]);

  const organizationID = useUserStore((state) => state.orgId);

  const [createRuleMutation, { loading, error }] = useMutation<CreateRuleMutation,CreateRuleMutationVariables>(
    CreateRuleDocument, {
      onCompleted() {
        toast(CustomToastComponent, {
          toastId: "rule-created-success",
          data: {
            title: t("toasts.rulecreated"),
            type: "success",
          },
        });
      },
      refetchQueries: [
        {
          query: RulesDocument,
          variables: { organizationId: Number(organizationID), decisionType },
        },
      ],
    });

  return {
    createRuleMutation,
    loading,
    error,
  };
}
